import { useEffect, useRef, useState } from "react";

import { nonNullable } from "shared/functions";

// https://github.com/react-dropzone/react-dropzone/issues/753
function useDragging(
  maxFileSize: number,
  onDropFiles: (files: File[]) => void,
  setDropError: React.Dispatch<React.SetStateAction<string>>,
) {
  const [isDragging, setIsDragging] = useState(false);

  const dragCounter = useRef(0);

  useEffect(() => {
    const onDragEnter = (evt: DragEvent) => {
      evt.preventDefault();
      dragCounter.current++;
      setDropError("");
      setIsDragging(true);
    };

    const onDragOver = (evt: DragEvent) => {
      evt.preventDefault();
    };

    const onDragLeave = () => {
      dragCounter.current--;
      if (!dragCounter.current) {
        setIsDragging(false);
        setDropError("");
      }
    };

    const onDrop = (evt: DragEvent) => {
      evt.preventDefault();
      dragCounter.current = 0;
      onDropFiles([...(evt.dataTransfer?.files || [])].filter(nonNullable));
      setIsDragging(false);
    };

    document.body.addEventListener("dragenter", onDragEnter, false);
    document.body.addEventListener("dragover", onDragOver, false);
    document.body.addEventListener("dragleave", onDragLeave, false);
    document.body.addEventListener("drop", onDrop, false);
    return () => {
      document.body.removeEventListener("dragenter", onDragEnter, false);
      document.body.removeEventListener("dragover", onDragOver, false);
      document.body.removeEventListener("dragleave", onDragLeave, false);
      document.body.removeEventListener("drop", onDrop, false);
    };
  }, [onDropFiles, setDropError, maxFileSize]);

  return {
    isDragging,
  };
}

export default useDragging;
